// Constants for dropdown options

// Regions
export const REGIONS = [
  { value: 'asia', label: 'Asia' },
  { value: 'emea', label: 'EMEA' },
  { value: 'americas', label: 'Americas' },
];

// Countries - comprehensive global list
export const COUNTRIES = [
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BR', label: 'Brazil' },
  { value: 'BN', label: 'Brunei' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CA', label: 'Canada' },
  { value: 'CV', label: 'Cape Verde' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CG', label: 'Congo' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GR', label: 'Greece' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KP', label: 'North Korea' },
  { value: 'KR', label: 'South Korea' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: 'Laos' },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MO', label: 'Macau' },
  { value: 'MK', label: 'North Macedonia' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia' },
  { value: 'MD', label: 'Moldova' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PS', label: 'Palestine' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'QA', label: 'Qatar' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russia' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'KN', label: 'Saint Kitts and Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome and Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'SS', label: 'South Sudan' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudan' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SZ', label: 'Eswatini' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syria' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VA', label: 'Vatican City' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Vietnam' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' },
];

// FY26 Solution Areas and Solution Plays mapping
export const SOLUTION_AREAS = [
  { value: 'cloud_ai_platform', label: 'Cloud and AI Platform' },
  { value: 'security', label: 'Security' },
  { value: 'abs_ai_business_process', label: 'AI Business Solutions - AI Business Process' },
  { value: 'abs_ai_workforce', label: 'AI Business Solutions - AI Workforce' },
];

export const SOLUTION_PLAYS = {
  cloud_ai_platform: [
    { value: 'migrate_modernize', label: 'Migrate and modernize your estate' },
    { value: 'unify_data_platform', label: 'Unify Your Data Platform' },
    { value: 'innovate_azure_ai', label: 'Innovate with Azure AI Apps and Agents' },
  ],
  security: [
    { value: 'modern_secops', label: 'Modern SecOps with Unified Platform' },
    { value: 'data_security', label: 'Data Security' },
    { value: 'protect_cloud_ai', label: 'Protect cloud, AI Platform and Apps' },
  ],
  abs_ai_business_process: [
    { value: 'sales_transformation', label: 'Sales Transformation with AI' },
    { value: 'service_transformation', label: 'Service Transformation with AI' },
    { value: 'erp_transformation', label: 'ERP Transformation with AI' },
    { value: 'low_code_ai', label: 'Innovate with Low Code AI and Agents' },
    { value: 'scale_business_ops', label: 'Scale Business Operations with AI' },
  ],
  abs_ai_workforce: [
    { value: 'copilot_agents', label: 'Copilot and Agents at Work' },
    { value: 'secure_ai_productivity', label: 'Secure AI Productivity' },
    { value: 'cloud_ai_endpoints', label: 'Scale with Cloud and AI Endpoints' },
    { value: 'converged_comms', label: 'Converged Communications (Partner Led)' },
  ],
};

// Get Solution Plays for a given Solution Area
export const getSolutionPlays = (solutionArea) => {
  return SOLUTION_PLAYS[solutionArea] || [];
};

// Get label for a Solution Area
export const getSolutionAreaLabel = (value) => {
  const area = SOLUTION_AREAS.find(a => a.value === value);
  return area?.label || value;
};

// Get label for a Solution Play
export const getSolutionPlayLabel = (solutionArea, playValue) => {
  const plays = SOLUTION_PLAYS[solutionArea];
  if (!plays) return playValue;
  const play = plays.find(p => p.value === playValue);
  return play?.label || playValue;
};

// Global Timezones
export const TIMEZONES = [
  { value: 'UTC', label: 'UTC (Coordinated Universal Time)' },
  // Americas
  { value: 'America/New_York', label: 'Eastern Time (ET) - New York' },
  { value: 'America/Chicago', label: 'Central Time (CT) - Chicago' },
  { value: 'America/Denver', label: 'Mountain Time (MT) - Denver' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT) - Los Angeles' },
  { value: 'America/Anchorage', label: 'Alaska Time - Anchorage' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time - Honolulu' },
  { value: 'America/Phoenix', label: 'Arizona Time - Phoenix' },
  { value: 'America/Toronto', label: 'Eastern Time - Toronto' },
  { value: 'America/Vancouver', label: 'Pacific Time - Vancouver' },
  { value: 'America/Mexico_City', label: 'Central Time - Mexico City' },
  { value: 'America/Sao_Paulo', label: 'Brasilia Time - São Paulo' },
  { value: 'America/Buenos_Aires', label: 'Argentina Time - Buenos Aires' },
  { value: 'America/Santiago', label: 'Chile Time - Santiago' },
  { value: 'America/Bogota', label: 'Colombia Time - Bogota' },
  // Europe
  { value: 'Europe/London', label: 'Greenwich Mean Time (GMT) - London' },
  { value: 'Europe/Dublin', label: 'Irish Time - Dublin' },
  { value: 'Europe/Paris', label: 'Central European Time (CET) - Paris' },
  { value: 'Europe/Berlin', label: 'Central European Time - Berlin' },
  { value: 'Europe/Amsterdam', label: 'Central European Time - Amsterdam' },
  { value: 'Europe/Brussels', label: 'Central European Time - Brussels' },
  { value: 'Europe/Madrid', label: 'Central European Time - Madrid' },
  { value: 'Europe/Rome', label: 'Central European Time - Rome' },
  { value: 'Europe/Zurich', label: 'Central European Time - Zurich' },
  { value: 'Europe/Stockholm', label: 'Central European Time - Stockholm' },
  { value: 'Europe/Warsaw', label: 'Central European Time - Warsaw' },
  { value: 'Europe/Prague', label: 'Central European Time - Prague' },
  { value: 'Europe/Athens', label: 'Eastern European Time - Athens' },
  { value: 'Europe/Helsinki', label: 'Eastern European Time - Helsinki' },
  { value: 'Europe/Moscow', label: 'Moscow Time - Moscow' },
  { value: 'Europe/Istanbul', label: 'Turkey Time - Istanbul' },
  // Middle East
  { value: 'Asia/Dubai', label: 'Gulf Standard Time - Dubai' },
  { value: 'Asia/Riyadh', label: 'Arabia Standard Time - Riyadh' },
  { value: 'Asia/Jerusalem', label: 'Israel Time - Jerusalem' },
  { value: 'Asia/Tehran', label: 'Iran Time - Tehran' },
  // Asia
  { value: 'Asia/Kolkata', label: 'India Standard Time (IST) - Mumbai/Delhi' },
  { value: 'Asia/Karachi', label: 'Pakistan Time - Karachi' },
  { value: 'Asia/Dhaka', label: 'Bangladesh Time - Dhaka' },
  { value: 'Asia/Bangkok', label: 'Indochina Time - Bangkok' },
  { value: 'Asia/Ho_Chi_Minh', label: 'Indochina Time - Ho Chi Minh' },
  { value: 'Asia/Jakarta', label: 'Western Indonesia Time - Jakarta' },
  { value: 'Asia/Singapore', label: 'Singapore Time - Singapore' },
  { value: 'Asia/Kuala_Lumpur', label: 'Malaysia Time - Kuala Lumpur' },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong Time - Hong Kong' },
  { value: 'Asia/Shanghai', label: 'China Standard Time - Shanghai/Beijing' },
  { value: 'Asia/Taipei', label: 'Taiwan Time - Taipei' },
  { value: 'Asia/Manila', label: 'Philippines Time - Manila' },
  { value: 'Asia/Seoul', label: 'Korea Standard Time - Seoul' },
  { value: 'Asia/Tokyo', label: 'Japan Standard Time - Tokyo' },
  // Oceania
  { value: 'Australia/Perth', label: 'Australian Western Time - Perth' },
  { value: 'Australia/Adelaide', label: 'Australian Central Time - Adelaide' },
  { value: 'Australia/Sydney', label: 'Australian Eastern Time - Sydney' },
  { value: 'Australia/Melbourne', label: 'Australian Eastern Time - Melbourne' },
  { value: 'Australia/Brisbane', label: 'Australian Eastern Time - Brisbane' },
  { value: 'Pacific/Auckland', label: 'New Zealand Time - Auckland' },
  { value: 'Pacific/Fiji', label: 'Fiji Time - Suva' },
  // Africa
  { value: 'Africa/Johannesburg', label: 'South Africa Time - Johannesburg' },
  { value: 'Africa/Cairo', label: 'Egypt Time - Cairo' },
  { value: 'Africa/Lagos', label: 'West Africa Time - Lagos' },
  { value: 'Africa/Nairobi', label: 'East Africa Time - Nairobi' },
];

// Get label for a Timezone
export const getTimezoneLabel = (value) => {
  const tz = TIMEZONES.find(t => t.value === value);
  return tz?.label || value;
};
